import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

declare var $: any;

@Component({
    selector: 'app-freight',
    templateUrl: './freight.component.html',
    styleUrls: ['./freight.component.css']
})
export class FreightComponent implements OnInit {
    tittle = 'FREIGHT';
    setFullWindow = false;
    constructor(private router: Router) { }

    ngOnInit() {
        $('.page-contents').animate({ scrollLeft: $('#levelOne').width() }, 400);
    }

    close() {
        // this.closeService.closeEvent(type.CATALOGUE);
        console.log('close event');
        $('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
        // routerLink = '/buy'
        this.router.navigateByUrl('/aboutInfo');
    }
}
